module.exports = "<app-photo-view photo-list=$ctrl.route.photos main-lang=$ctrl.route.main_lang> </app-photo-view> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/view/photos/partial.html
// module id = 508
// module chunks = 0